import React from 'react';

import {
    Checkbox, Group,
} from '@mantine/core';

function DataTableFilters({
    currentParams,
    filters = {},
    onChange,
}) {
    return (
        <Group align="center">
            {Object.entries(filters).map(([type, values]) => (
                <div
                    key={type}
                    className="data-table__filter-group"
                >
                    {values.map(({ value, label }) => (
                        <Checkbox
                            key={`${type}-${value}`}
                            value={value}
                            checked={currentParams[type] === value}
                            label={label}
                            data-type={type}
                            onChange={onChange}
                        />
                    ))}
                </div>
            ))}
        </Group>
    );
}

export default DataTableFilters;
